import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import deLocale from '@fullcalendar/core/locales/de';

console.log('test');
document.addEventListener('DOMContentLoaded', function() {

  var calendarEl = document.getElementById('calendar');
  if (calendarEl) {



    async function fetchSeminare() {
      try {
        // let response = await fetch('http://wer-akademie.local/dd-seminar/json/seminare');
        let response = await fetch('https://wr-akademie.weisser-ring.de/dd-seminar/json/seminare');
        return response.json()
      } catch(err) {
        console.log(err);
      }
    }

    async function renderSeminare() {
      let seminare = await fetchSeminare();

      var calendar = new Calendar(calendarEl, {
        plugins: [ dayGridPlugin, listPlugin ],
        events: seminare,
        firstDay: 1,
        locale: deLocale,
        // datesSet: filterLocation(),
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,listMonth"
        },
        buttonText: {
          list: 'Monatsliste',
          month: 'Kalender'
        },
        loading: function( isLoading ) {
          if (isLoading == true) {
            console.log('is loading')
          } else {
            console.log('is done')
            document.getElementById('loader').style.display = 'none';
          }
        }

      });

      calendar.render();
      renderList(seminare);
      var events = calendar.getEvents();
    }

    // Render Seminare
    renderSeminare();


    // Location Select List
    async function fetchLocations() {
      try {
        // let response = await fetch('http://wer-akademie.local/dd-seminar/json/locations');
        let response = await fetch('https://wr-akademie.weisser-ring.de/dd-seminar/json/locations');
        return response.json()
      } catch(err) {
        console.log(err);
      }
    }
    async function renderLocations() {
      let locations = await fetchLocations();
      var location_select = document.getElementById("dd-seminar__location-list");
      Object.keys(locations).forEach(function(key){
        var el = document.createElement("option");
        el.textContent = locations[key].title;
        el.value = locations[key].nid;
        location_select.appendChild(el);
      });
    }


    // Init
    setTimeout(function(){
      renderLocations();
      renderTypes();
      scrollEvents();
      formatTimeStrings();
    }, 2000);//wait 2 seconds
    

    // Filter 

    // DROPDOWNS
    var location_select = document.getElementById("dd-seminar__location-list");
    var type_select = document.getElementById("dd-seminar__types-list");
    location_select.addEventListener("change", function() {
      filterEvents();
    });
    type_select.addEventListener("change", function() {
      filterEvents();
    });

    // BUTTONS
    setTimeout(function(){
    var cal_buttons = document.querySelectorAll('.fc-header-toolbar button');
      cal_buttons.forEach(function(button) {
        button.addEventListener('click', function(){
          scrollEvents();
          filterEvents();
          formatTimeStrings();
        });
      });
    }, 2000);//wait 2 seconds


    function filterEvents(){
      var type_select = document.getElementById("dd-seminar__types-list");
      var location_select = document.getElementById("dd-seminar__location-list");
      var chosenLocation = location_select.value;
      var chosenType = type_select.value;

      if (chosenType == 'show-all' && chosenLocation == 'show-all') {
        var items = document.querySelectorAll('.dd-calendar__item');
        items.forEach(function(item) {
          item.classList.add('dd-seminar--show');
        })
      } else {
        var allitems = document.querySelectorAll('.dd-calendar__item');
        allitems.forEach(function(calitem) {
          calitem.classList.remove('dd-seminar--show');          
          if (calitem.classList.contains('dd-seminar-location--' + chosenLocation) && calitem.classList.contains('dd-seminar-type--' + chosenType) ) {
            calitem.classList.add('dd-seminar--show');          
          }
          if (calitem.classList.contains('dd-seminar-location--' + chosenLocation) && chosenType == 'show-all' ) {
            calitem.classList.add('dd-seminar--show');          
          }
          if ((chosenLocation == 'show-all') && calitem.classList.contains('dd-seminar-type--' + chosenType) ) {
            calitem.classList.add('dd-seminar--show');          
          }
        })
      }
      checkIfEventsLeft();
    }

    function checkIfEventsLeft(){
      var active_events = document.querySelectorAll(".dd-seminar--show");
      if (active_events.length) {
        console.log('Events verfügbar');
      } else {
        alert('Keine Termine für diese Auswahl verfügbar.')
      }
    }

    // Type Select List
    async function fetchTypes() {
      try {
        // let response = await fetch('http://wer-akademie.local/dd-seminar/json/types');
        let response = await fetch('https://wr-akademie.weisser-ring.de/dd-seminar/json/types');
        return response.json()
      } catch(err) {
        console.log(err);
      }
    }
    async function renderTypes() {
      let types = await fetchTypes();
      var type_select = document.getElementById("dd-seminar__types-list");
      Object.keys(types).forEach(function(key){
        var el = document.createElement("option");
        el.textContent = types[key].title;
        el.value = types[key].id;
        type_select.appendChild(el);
      });
    }
    function renderList(seminare){
      var container = document.getElementById('seminar-list');
      seminare.forEach(function(seminar){
        var classNamesString = seminar.classNames.toString();
        var classNames = classNamesString.replace(/,/g, ' ')
        var date = seminar.extendedProps.formatted_date;
        container.insertAdjacentHTML('beforeend', '<a href="' + seminar.url + '" class="' + seminar.extendedProps.upcoming + ' dd-calendar__item calendar-item calendar-item--border dd-seminar--show calendar-status--' + seminar.extendedProps.status + ' ' + classNames + '" ><div class="calendar-item__heading"><h3><span class="txt-inner">' + seminar.title + '</span></h3><div class="icon icon--' + seminar.extendedProps.attendees + '"></div></div><div class="calendar-item__date"><h5>Beginn und Ende des Seminars</h5><p>' + date  + '</p></div><div class="calendar-item__place"><h5>Ort</h5><p>' + seminar.extendedProps.location + '</p></div><div class="calendar-item__book"><span class="button button--primary" href="#">Zum Seminar anmelden</span></div></a>');
      });
    }

    function scrollEvents() {
      var calendarEvents = document.querySelectorAll('.fc-daygrid-event');
      calendarEvents.forEach(function(event_item) {
        var bar_length = event_item.offsetWidth
        var title_length = event_item.querySelector('.fc-event-title').offsetWidth
        if (bar_length <= title_length) {
          event_item.classList.add('scrollable');
        }
      });
    }


    function formatTimeStrings() {
      var calendarEvents = document.querySelectorAll('.fc-list-event-time');
      calendarEvents.forEach(function(event) {
        var string = event.innerHTML;
        if (string.startsWith('0:00')) {
          var newString = string.replace('0:00 - ', "")
          event.innerHTML = 'bis ' + newString;
        }

        if (string.startsWith('00:00')) {
          var newString = string.replace('00:00 - ', "")
          event.innerHTML = 'bis ' + newString;
        }

        if (string.endsWith('0:00')) {
          var newString = string.replace(' - 0:00', "")
          event.innerHTML = 'ab ' + newString;
        }

        if (string.endsWith('00:00')) {
          var newString = string.replace(' - 00:00', "")
          event.innerHTML = 'ab ' + newString;
        }

      })
    }

  }



})


    
